import React from "react";
import styles from "./styles.module.scss";

type TextElement = HTMLParagraphElement | HTMLHeadingElement | HTMLSpanElement;

interface TextProps extends React.HTMLAttributes<TextElement> {
  typography?: keyof typeof styles;
  as?: "p" | "h1" | "h2" | "h3" | "h4" | "h5" | "h6" | "span";
  className?: string;
}

export function Text({
  typography = "p1",
  as: Component = "p",
  className = "",
  children,
  ...props
}: TextProps) {
  const typographyClass = styles[typography];

  return (
    <Component className={`${typographyClass} ${className}`} {...props}>
      {children}
    </Component>
  );
}
